<template>
  <div class="margin-subpages">
    <div class="fs-18 fw-700 pb-24 pt-6">{{ $t("awards.happily_awards") }}</div>
    <div class="grid-2">
      <div class="awards-card">
        <div class="box-image flex-mid">
          <div class="relative">
            <img
              :class="`img-banner ${
                recognitionDrivenLoading
                  ? 'gray'
                  : checkedProgress(
                      recognitionDriven.percentage,
                      recognitionDriven.required
                    )
                  ? ''
                  : 'gray'
              }`"
              src="@/assets/images/awards/recognition-driven.png"
            />
          </div>
        </div>
        <div>
          <div class="fs-16 fw-900">{{ $t("awards.recognition_driven") }}</div>
          <div class="fs-12">
            {{ $t("awards.the_practice_of") }}
          </div>
          <div v-if="!recognitionDrivenLoading">
            <div class="flex mt-24">
              <div class="fs-12 fw-700 pt-2">
                {{ $t("awards.past_thirty_day_participation") }}
              </div>
              <div
                class="fs-14 fw-900 ml-auto"
                :style="`color: ${
                  checkedProgress(
                    recognitionDriven.percentage,
                    recognitionDriven.required
                  )
                    ? '#F97628'
                    : '#737373'
                };`"
              >
                {{ recognitionDriven.percentage }}%
              </div>
            </div>
            <el-progress
              class="mt-4"
              :percentage="recognitionDriven.percentage"
              :color="
                checkedProgress(
                  recognitionDriven.percentage,
                  recognitionDriven.required
                )
                  ? '#F97628'
                  : '#737373'
              "
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <div class="fs-12 fw-700 opa-08 mt-6">
              {{ $t("awards.required") }}: {{ recognitionDriven.required }}%
              {{ $t("awards.or_higher") }}
            </div>
            <div
              class="ml-auto fs-12 fw-700"
              style="color: #4708ac; width: 44px"
            >
              <div
                v-if="
                  checkedProgress(
                    recognitionDriven.percentage,
                    recognitionDriven.required
                  )
                "
                class="cursor-pointer"
                @click.prevent="shareModal('recognitionDriven')"
              >
                {{ $t("global.SHARE") }}
              </div>
              <div v-else class="opa-04">{{ $t("global.SHARE") }}</div>
            </div>
          </div>
          <div v-else class="mt-24">
            <div class="flex-center">
              <div class="text-skeleton fs-12" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 ml-auto" style="width: 34px">
                &nbsp;
              </div>
            </div>
            <div class="text-skeleton fs-8 mt-4 bd-r-4" style="width: 100%">
              &nbsp;
            </div>
            <div class="text-skeleton fs-12 mt-4" style="width: 90px">
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div class="awards-card">
        <div class="box-image flex-mid">
          <div class="relative">
            <img
              :class="`img-banner ${
                recognitionDrivenLoading
                  ? 'gray'
                  : openFeedback.percentage > openFeedback.required - 1
                  ? ''
                  : 'gray'
              }`"
              src="@/assets/images/awards/open-feedback.png"
            />
          </div>
        </div>
        <div>
          <div class="fs-16 fw-900">{{ $t("awards.open_feedback") }}</div>
          <div class="fs-12">
            {{ $t("awards.continuous_feedback_drives") }}:
          </div>
          <div v-if="!openFeedbackLoading">
            <div class="flex mt-24">
              <div class="fs-12 fw-700 pt-2">
                {{ $t("awards.past_thirty_day_open") }}:
              </div>
              <div
                class="fs-14 fw-900 ml-auto"
                :style="`color: ${
                  checkedProgress(
                    openFeedback.percentage,
                    openFeedback.required
                  )
                    ? '#549814'
                    : '#737373'
                };`"
              >
                {{ openFeedback.percentage }}%
              </div>
            </div>
            <el-progress
              class="mt-4"
              :percentage="openFeedback.percentage"
              :color="
                checkedProgress(openFeedback.percentage, openFeedback.required)
                  ? '#549814'
                  : '#8B8B8B'
              "
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <div class="fs-12 fw-700 opa-08 mt-6">
              {{ $t("awards.required") }}: {{ openFeedback.required }}%
              {{ $t("awards.or_higher") }}
            </div>
            <div
              class="ml-auto fs-12 fw-700"
              style="color: #4708ac; width: 44px"
            >
              <div
                v-if="
                  checkedProgress(
                    openFeedback.percentage,
                    openFeedback.required
                  )
                "
                class="cursor-pointer"
                @click.prevent="shareModal('openFeedback')"
              >
                {{ $t("global.SHARE") }}
              </div>
              <div v-else class="opa-04">{{ $t("global.SHARE") }}</div>
            </div>
          </div>
          <div v-else class="mt-24">
            <div class="flex-center">
              <div class="text-skeleton fs-12" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 ml-auto" style="width: 34px">
                &nbsp;
              </div>
            </div>
            <div class="text-skeleton fs-8 mt-4 bd-r-4" style="width: 100%">
              &nbsp;
            </div>
            <div class="text-skeleton fs-12 mt-4" style="width: 90px">
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div class="awards-card">
        <div class="box-image flex-mid">
          <div class="relative">
            <img
              :class="`img-banner ${
                recognitionDrivenLoading
                  ? 'gray'
                  : checkedProgress(
                      activeManagers.percentage,
                      activeManagers.required
                    )
                  ? ''
                  : 'gray'
              }`"
              src="@/assets/images/awards/active_managers.png"
            />
          </div>
        </div>
        <div>
          <div class="fs-16 fw-900">{{ $t("awards.active_managers") }}:</div>
          <div class="fs-12">{{ $t("awards.people_managers_are") }}:</div>
          <div v-if="!activeManagersLoading">
            <div class="flex mt-24">
              <div class="fs-12 fw-700 pt-2">
                {{ $t("awards.past_thirty_day_activity") }}
              </div>
              <div
                class="fs-14 fw-900 ml-auto"
                :style="`color: ${
                  checkedProgress(
                    activeManagers.percentage,
                    activeManagers.required
                  )
                    ? '#1C356A'
                    : '#737373'
                };`"
              >
                {{ activeManagers.percentage }}%
              </div>
            </div>
            <el-progress
              class="mt-4"
              :percentage="activeManagers.percentage"
              :color="
                checkedProgress(
                  activeManagers.percentage,
                  activeManagers.required
                )
                  ? '#1C356A'
                  : '#8B8B8B'
              "
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <div class="fs-12 fw-700 opa-08 mt-6">
              {{ $t("awards.required") }}: {{ activeManagers.required }}%
              {{ $t("awards.or_higher") }}
            </div>
            <div
              class="ml-auto fs-12 fw-700"
              style="color: #4708ac; width: 44px"
            >
              <div
                v-if="
                  checkedProgress(
                    activeManagers.percentage,
                    activeManagers.required
                  )
                "
                class="cursor-pointer"
                @click.prevent="shareModal('activeManagers')"
              >
                {{ $t("global.SHARE") }}
              </div>
              <div v-else class="opa-04">{{ $t("global.SHARE") }}</div>
            </div>
          </div>
          <div v-else class="mt-24">
            <div class="flex-center">
              <div class="text-skeleton fs-12" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 ml-auto" style="width: 34px">
                &nbsp;
              </div>
            </div>
            <div class="text-skeleton fs-8 mt-4 bd-r-4" style="width: 100%">
              &nbsp;
            </div>
            <div class="text-skeleton fs-12 mt-4" style="width: 90px">
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div class="awards-card">
        <div class="box-image flex-mid">
          <div class="relative">
            <img
              :class="`img-banner ${
                recognitionDrivenLoading
                  ? 'gray'
                  : checkedProgress(
                      strongCompanyCulture.percentage,
                      strongCompanyCulture.required
                    )
                  ? ''
                  : 'gray'
              }`"
              src="@/assets/images/awards/strong_core_values.png"
            />
          </div>
        </div>
        <div>
          <div class="fs-16 fw-900">
            {{ $t("awards.strong_company_culture") }}
          </div>
          <div class="fs-12">
            {{ $t("awards.culture_is_a_byproduct") }}
          </div>
          <div v-if="!strongCompanyCultureLoading">
            <div class="flex mt-24">
              <div class="fs-12 fw-700 pt-2">
                {{ $t("awards.most_recent_culture") }}
              </div>
              <div
                class="fs-14 fw-900 ml-auto"
                :style="`color: ${
                  checkedProgress(
                    strongCompanyCulture.percentage,
                    strongCompanyCulture.required
                  )
                    ? '#7E0F06'
                    : '#737373'
                };`"
              >
                {{ $utils("addCommasInNumber", strongCompanyCulture.value) }}
              </div>
            </div>
            <el-progress
              class="mt-4"
              :percentage="strongCompanyCulture.percentage"
              :color="
                checkedProgress(
                  strongCompanyCulture.percentage,
                  strongCompanyCulture.required
                )
                  ? '#7E0F06'
                  : '#8B8B8B'
              "
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <div class="fs-12 fw-700 opa-08 mt-6">
              {{ $t("awards.required") }}: {{ strongCompanyCulture.required }}
              {{ $t("awards.or_higher") }}
            </div>
            <div
              class="ml-auto fs-12 fw-700"
              style="color: #4708ac; width: 44px"
            >
              <div
                v-if="
                  checkedProgress(
                    strongCompanyCulture.percentage,
                    strongCompanyCulture.required
                  )
                "
                class="cursor-pointer"
                @click.prevent="shareModal('strongCompanyCulture')"
              >
                {{ $t("global.SHARE") }}
              </div>
              <div v-else class="opa-04">{{ $t("global.SHARE") }}</div>
            </div>
          </div>
          <div v-else class="mt-24">
            <div class="flex-center">
              <div class="text-skeleton fs-12" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 ml-auto" style="width: 34px">
                &nbsp;
              </div>
            </div>
            <div class="text-skeleton fs-8 mt-4 bd-r-4" style="width: 100%">
              &nbsp;
            </div>
            <div class="text-skeleton fs-12 mt-4" style="width: 90px">
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div class="awards-card">
        <div class="box-image flex-mid">
          <div class="relative">
            <img
              :class="`img-banner ${
                recognitionDrivenLoading
                  ? 'gray'
                  : checkedProgress(
                      highWellBeing.percentage,
                      highWellBeing.required
                    )
                  ? ''
                  : 'gray'
              }`"
              src="@/assets/images/awards/high_well-being.png"
            />
          </div>
        </div>
        <div>
          <div class="fs-16 fw-900">{{ $t("awards.high_well_being") }}</div>
          <div class="fs-12">
            {{ $t("awards.employee_wellness_and") }}
          </div>
          <div v-if="!highWellBeingLoading">
            <div class="flex mt-24">
              <div class="fs-12 fw-700 pt-2">
                {{ $t("awards.most_recent_WHO_5") }}
              </div>
              <div
                class="fs-14 fw-900 ml-auto"
                :style="`color: ${
                  checkedProgress(
                    highWellBeing.percentage,
                    highWellBeing.required
                  )
                    ? '#549814'
                    : '#737373'
                };`"
              >
                {{ $utils("addCommasInNumber", highWellBeing.value) }}
              </div>
            </div>
            <el-progress
              class="mt-4"
              :percentage="highWellBeing.percentage"
              :color="
                checkedProgress(
                  highWellBeing.percentage,
                  highWellBeing.required
                )
                  ? '#549814'
                  : '#8B8B8B'
              "
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <div class="fs-12 fw-700 opa-08 mt-6">
              {{ $t("awards.required") }}: {{ highWellBeing.required }}
              {{ $t("awards.or_higher") }}
            </div>
            <div
              class="ml-auto fs-12 fw-700"
              style="color: #4708ac; width: 44px"
            >
              <div
                v-if="
                  checkedProgress(
                    highWellBeing.percentage,
                    highWellBeing.required
                  )
                "
                class="cursor-pointer"
                @click.prevent="shareModal('highWellBeing')"
              >
                {{ $t("global.SHARE") }}
              </div>
              <div v-else class="opa-04">{{ $t("global.SHARE") }}</div>
            </div>
          </div>
          <div v-else class="mt-24">
            <div class="flex-center">
              <div class="text-skeleton fs-12" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 ml-auto" style="width: 34px">
                &nbsp;
              </div>
            </div>
            <div class="text-skeleton fs-8 mt-4 bd-r-4" style="width: 100%">
              &nbsp;
            </div>
            <div class="text-skeleton fs-12 mt-4" style="width: 90px">
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div
        id="happiest_workplace"
        class="awards-card fc-FFFFFF"
        style="background-color: #6c30cc"
      >
        <div class="box-image flex-mid">
          <div class="relative">
            <img
              :class="`img-banner ${
                recognitionDrivenLoading
                  ? 'gray'
                  : happiestWorkplace.value == happiestWorkplace.required
                  ? ''
                  : 'gray'
              }`"
              src="@/assets/images/awards/happiest_workplace.png"
            />
          </div>
        </div>
        <div>
          <div class="fs-16 fw-900">{{ $t("awards.happiest_workplace") }}</div>
          <div class="fs-12">
            {{ $t("awards.a_happy_workplace") }}
          </div>
          <div
            v-if="
              !(
                recognitionDrivenLoading &&
                openFeedbackLoading &&
                activeManagersLoading &&
                strongCompanyCultureLoading &&
                highWellBeingLoading
              )
            "
          >
            <div class="flex mt-24">
              <div class="fs-12 fw-700 pt-2">
                {{ $t("awards.awards_collected") }}
              </div>
              <div
                class="fs-14 fw-900 ml-auto"
                :style="`color: ${
                  happiestWorkplace.value == happiestWorkplace.required
                    ? '#FFFFFF'
                    : '#FFFFFF'
                };`"
              >
                {{ happiestWorkplace.percentage }}%
              </div>
            </div>
            <el-progress
              class="mt-4"
              :percentage="happiestWorkplace.percentage"
              :color="
                happiestWorkplace.value == happiestWorkplace.required
                  ? '#FFFFFF'
                  : '#FFFFFF'
              "
              :stroke-width="8"
              :show-text="false"
            ></el-progress>
            <div class="fs-12 fw-700 opa-08 mt-6">
              {{ $t("awards.required") }}: {{ $t("awards.collect_all_other") }}
            </div>
            <div
              class="ml-auto fs-12 fw-700"
              style="color: #ffffff; width: 44px"
            >
              <div
                v-if="happiestWorkplace.value == happiestWorkplace.required"
                class="cursor-pointer"
                @click.prevent="shareModal('happiestWorkplace')"
              >
                {{ $t("global.SHARE") }}
              </div>
              <div v-else class="opa-03">{{ $t("global.SHARE") }}</div>
            </div>
          </div>
          <div v-else class="mt-24">
            <div class="flex-center">
              <div class="text-skeleton fs-12" style="width: 140px">&nbsp;</div>
              <div class="text-skeleton fs-14 ml-auto" style="width: 34px">
                &nbsp;
              </div>
            </div>
            <div class="text-skeleton fs-8 mt-4 bd-r-4" style="width: 100%">
              &nbsp;
            </div>
            <div class="text-skeleton fs-12 mt-4" style="width: 90px">
              &nbsp;
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2"></div>
    </div>
    <el-dialog
      :visible.sync="modalShareStatus"
      width="639px"
      top="5vh"
      class="remove-padding-modal"
    >
      <div class="shere-modal">
        <div class="top center">
          <div>
            <div class="relative m-auto img-box">
              <img
                v-if="modalShareValue.img"
                class="img-banner"
                :src="getImage(modalShareValue.img)"
              />
            </div>
            <div class="fs-24 fw-900 fc-FFFFFF mt-40">
              {{ $t("awards.share_your_award") }}
            </div>
          </div>
        </div>
        <div class="buttom">
          <el-tabs v-model="modalShareValue.tab">
            <el-tab-pane name="shareLink" default>
              <span slot="label" class="title-bar">Share Link</span>
              <div>
                <div class="fs-16 mt-32 fc-000000 center word-break">
                  {{ $t("awards.share_your_award_with") }}
                </div>
                <div class="input-link flex-center">
                  <div class="link ellipsis">
                    {{ modalShareValue.link }}
                  </div>
                  <div @click="copyURL('link')" class="coppy">
                    {{ $t("awards.coppy") }}
                  </div>
                </div>
                <div class="preview">
                  <span class="cursor-pointer">{{
                    $t("awards.preview_link_in")
                  }}</span>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="embedCode">
              <span slot="label" class="title-bar">{{
                $t("awards.embed_code")
              }}</span>
              <div class="fs-16 mt-32 fc-000000 center word-break">
                {{ $t("awards.to_embed_this") }}
              </div>
              <div class="input-code">
                <div class="code">
                  <div
                    class="decode"
                    ref="decode"
                    v-html="modalShareValue.code"
                  ></div>
                </div>
                <div @click="copyURL('code')" class="coppy">
                  {{ $t("awards.coppy") }}
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "status-subpages",
  created() {
    // this.$store.dispatch("awards/getCultureAndHighWellBeing");
  },
  computed: {
    openFeedback() {
      return this.$store.getters["awards/openFeedback"];
    },
    recognitionDriven() {
      return this.$store.getters["awards/recognitionDriven"];
    },
    activeManagers() {
      return this.$store.getters["awards/activeManagers"];
    },
    strongCompanyCulture() {
      return this.$store.getters["awards/strongCompanyCulture"];
    },
    highWellBeing() {
      return this.$store.getters["awards/highWellBeing"];
    },
    recognitionDrivenLoading() {
      return this.$store.getters["awards/recognitionDrivenLoading"];
    },
    openFeedbackLoading() {
      return this.$store.getters["awards/openFeedbackLoading"];
    },
    activeManagersLoading() {
      return this.$store.getters["awards/activeManagersLoading"];
    },
    strongCompanyCultureLoading() {
      return this.$store.getters["awards/strongCompanyCultureLoading"];
    },
    highWellBeingLoading() {
      return this.$store.getters["awards/highWellBeingLoading"];
    },
  },
  watch: {
    openFeedback() {
      if (this.openFeedback.percentage > 0) {
        this.happiestWorkplaceSetData("openFeedback");
      }
    },
    recognitionDriven() {
      if (this.recognitionDriven.percentage > 0) {
        this.happiestWorkplaceSetData("recognitionDriven");
      }
    },
    activeManagers() {
      if (this.activeManagers.percentage > 0) {
        this.happiestWorkplaceSetData("activeManagers");
      }
    },
    strongCompanyCulture() {
      if (this.strongCompanyCulture.percentage > 0) {
        this.happiestWorkplaceSetData("strongCompanyCulture");
      }
    },
    highWellBeing() {
      if (this.highWellBeing.percentage > 0) {
        this.happiestWorkplaceSetData("highWellBeing");
      }
    },
  },
  data() {
    return {
      modalShareStatus: false,
      countHappiestWorkplace: 0,
      modalShareValue: {
        tab: "shareLink",
        img: "",
        code: "",
        link: "",
      },
      happiestWorkplace: {
        status: false,
        percentage: 0,
        value: 0,
        required: 5,
      },
    };
  },
  methods: {
    shareModal(value) {
      this.modalShareValue.tab = "shareLink";
      this.modalShareValue.code =
        "&lt;script charset=&quot;utf-8&quot; type=&quot;text/javascript&quot; src=&quot;//js.happily.ai/awards/shell.js&quot;&gt;";
      this.modalShareValue.link =
        "https://awards.happily.ai/verified/stark-industries";
      if (value && value == "recognitionDriven") {
        this.modalShareValue.img = "recognition-driven";
        this.modalShareStatus = true;
      } else if (value && value == "openFeedback") {
        this.modalShareValue.img = "open-feedback";
        this.modalShareStatus = true;
      } else if (value && value == "activeManagers") {
        this.modalShareValue.img = "active_managers";
        this.modalShareStatus = true;
      } else if (value && value == "strongCompanyCulture") {
        this.modalShareValue.img = "strong_core_values";
        this.modalShareStatus = true;
      } else if (value && value == "highWellBeing") {
        this.modalShareValue.img = "high_well-being";
        this.modalShareStatus = true;
      } else if (value && value == "happiestWorkplace") {
        this.modalShareValue.img = "happiest_workplace";
        this.modalShareStatus = true;
      }
    },
    copyURL(values) {
      let coppy = this.modalShareValue.link;
      if (values == "code") {
        coppy = this.$refs.decode.childNodes[0].data;
      }
      const clipboardData = window.clipboardData || navigator.clipboard;
      clipboardData.writeText(coppy);
      this.$message({
        message: "Copy " + values + " to clipboard.",
        type: "success",
      });
    },
    getImage(name) {
      return require("@/assets/images/awards/" + name + ".png");
    },
    decodeHTMLEntities(str) {
      if (str && typeof str === "string") {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
        element.innerHTML = str;
        str = element.textContent;
        element.textContent = "";
      }

      return str;
    },
    happiestWorkplaceSetData(type) {
      let currentDate = format(new Date(), "YYYY-MM-DD");

      if (
        this.recognitionDriven.percentage >= this.recognitionDriven.required &&
        type == "recognitionDriven"
      ) {
        this.countHappiestWorkplace++;
      }

      if (
        this.openFeedback.percentage >= this.openFeedback.required &&
        type == "openFeedback"
      ) {
        this.countHappiestWorkplace++;
      }
      if (
        this.activeManagers.percentage >= this.activeManagers.required &&
        type == "activeManagers"
      ) {
        this.countHappiestWorkplace++;
      }
      if (
        this.strongCompanyCulture.percentage >=
          this.strongCompanyCulture.required &&
        type == "strongCompanyCulture"
      ) {
        this.countHappiestWorkplace++;
      }
      if (
        this.highWellBeing.percentage >= this.highWellBeing.required &&
        type == "highWellBeing"
      ) {
        this.countHappiestWorkplace++;
      }
      this.happiestWorkplace.percentage = Math.round(
        (this.countHappiestWorkplace * 100) / 5
      );
      this.happiestWorkplace.required = 5;
    },
    checkedProgress(percentage, required) {
      if (percentage >= required) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.shere-modal {
  width: 100%;
  .top {
    height: 284px;
    width: 100%;
    background: transparent linear-gradient(248deg, #30b4cc 0%, #6c30cc 100%) 0%
      0% no-repeat padding-box;
    margin: auto;
    .img-box {
      padding: 85px 0 96px;
      width: 2px;
      height: 2px;
      .img-banner {
        width: 120px;
        position: absolute;
        left: 50%;
        right: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  .buttom {
    height: 416px;
    padding: 30px 40px;
    .input-link {
      margin-top: 32px;
      .link {
        font-size: 15px;
        color: #000;
        padding: 13px 24px;
        width: calc(100% - 138px);
        border: 1px solid #c7c7c7;
        border-width: 1px 0 1px 1px;
        background-color: #0000000d;
        border-radius: 4px 0 0 4px;
      }
      .coppy {
        padding: 13px 0;
        width: 90px;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        border: 1px solid #c7c7c7;
        background-color: #32c2d5;
        border-radius: 0 8px 8px 0;
        transition: 0.2s;
        cursor: pointer;
        &:hover {
          background-color: #2abbce;
        }
      }
    }
    .input-code {
      margin-top: 32px;
      .code {
        font-size: 15px;
        color: #000;
        padding: 16px 24px;
        height: 108px;
        border: 1px solid #c7c7c7;
        background-color: #0000000d;
        border-radius: 4px;

        .decode {
          height: 108px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 6;
          -webkit-box-orient: vertical;
        }
      }
      .coppy {
        padding: 13px 0;
        margin-top: 16px;
        width: 90px;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #fff;
        border: 1px solid #c7c7c7;
        background-color: #32c2d5;
        border-radius: 8px;
        transition: 0.2s;
        cursor: pointer;
        &:hover {
          background-color: #2abbce;
        }
      }
    }
    .preview {
      margin-top: 15px;
      color: #32c2d5;
      font-size: 16px;
      text-align: center;
    }
  }
}
.grid-2 {
  margin: 30px 0;
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 60px 16px;
  .awards-card {
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000029;
    padding: 16px 24px 16px 0;
    display: grid;
    grid-template-columns: auto 256px;
    width: calc(425px - 16px);
    .box-image {
      width: 100%;
      .relative {
        width: 2px;
        height: 2px;
      }
      .img-banner {
        width: 120px;
        position: absolute;
        left: 50%;
        right: 50%;
        transform: translate(-50%, -50%);
      }
      .gray {
        filter: grayscale(100%);
      }
    }
  }
}
</style>
<style lang="scss">
#happiest_workplace .el-progress-bar__outer {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
</style>